import { useCallback, useState } from 'react';

import { adminLocalizationApi, adminLocalizationKeys } from '@/api';
import { queryClient } from '@/app/QueryClientProvider';
import { ConstructorApi } from '@/features/constructor/api';
import { usePopups } from '@/hooks';

export const useCommentSection = (categoryScoringId) => {
  const { showErrorToast, showSuccessToast } = usePopups();
  const [isCreating, setIsCreating] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleCreate = useCallback(async (comment) => {
    try {
      setIsCreating(true);
      const result = await ConstructorApi.createComment(categoryScoringId, comment);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getAllScoringCategories],
          queryFn: () => adminLocalizationApi.getAllScoringCategories()
        });
        showSuccessToast('Created');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsCreating(false);
    }
  }, []);

  const handleUpdate = useCallback(async (commentId, comment) => {
    try {
      setIsUpdating(true);
      const result = await ConstructorApi.updateComment(commentId, comment);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getAllScoringCategories],
          queryFn: () => adminLocalizationApi.getAllScoringCategories()
        });
        showSuccessToast('Saved');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsUpdating(false);
    }
  }, []);

  const handleDelete = useCallback(async (comment) => {
    try {
      setIsDeleting(true);
      const result = await ConstructorApi.deleteComment(comment.id);
      if (result) {
        await queryClient.refetchQueries({
          queryKey: [adminLocalizationKeys.getAllScoringCategories],
          queryFn: () => adminLocalizationApi.getAllScoringCategories()
        });
        showSuccessToast('Deleted');
      }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsDeleting(false);
    }
  }, []);

  return {
    handleCreate,
    handleUpdate,
    handleDelete,
    isCreating,
    isUpdating,
    isDeleting
  };
};
